import script from "./HDFFooter03.vue?vue&type=script&setup=true&lang=js"
export * from "./HDFFooter03.vue?vue&type=script&setup=true&lang=js"

import "./HDFFooter03.vue?vue&type=style&index=0&id=3cea73ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cea73ad"]])

export default __exports__